import { render, staticRenderFns } from "./sfc-menu-v2.vue?vue&type=template&id=ea90056e&scoped=true&lang=pug&"
import script from "./sfc-menu-v2.vue?vue&type=script&lang=js&"
export * from "./sfc-menu-v2.vue?vue&type=script&lang=js&"
import style0 from "./sfc-menu-v2.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./sfc-menu-v2.vue?vue&type=style&index=1&id=ea90056e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea90056e",
  null
  
)

export default component.exports